<template>
  <b-container class="p-3" fluid>
    <div>
      <div v-for="(group, index) in groupFundings" :key="index">
        <h5> {{ group.name }}</h5>
        <table class="table table-striped table-bordered table-sm">
          <thead>
            <tr>
              <th class="text-center align-middle">ปีการศึกษา</th>
              <th class="text-center align-middle" width="150">ได้รับ</th>
              <th class="text-center align-middle" width="150">ใช้ไป</th>
              <th class="text-center align-middle" width="150">คงเหลือ</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="group.groupFundings.length">
              <tr v-for="(yearFund,yearFundIndex) in group.groupFundings" :key="yearFundIndex">
                <td> <router-link :to="{ name: 'budget.show',params:{id:yearFund.id} }"><a>{{ yearFund.acYear.year }}</a></router-link></td>
                <td class="text-center">{{ yearFund.receivedAmount | numeral("0,0.00") }}</td>
                <td class="text-center">{{ yearFund.usedAmount | numeral("0,0.00") }}</td>
                <td class="text-center">{{ yearFund.receivedAmount - yearFund.usedAmount | numeral("0,0.00") }}</td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td class="text-center" colspan="4">ไม่มีข้อมูล</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </b-container>
</template>
<script>
import gql from 'graphql-tag'

export default {
  apollo: {
    groupFundings: {
      query: gql`{
        groupFundings {
          name
          groupFundings {
            id
            receivedAmount
            usedAmount
            acYear {
              year
            }
          }
        }
      }`
    }
  }
}
</script>
